import { Router } from "@frui.ts/screens/dist";
import ColorDivider from "@edaz/edazkit/ColorDivider";
import Header from "@edaz/edazkit/Header";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";
import { Dropdown, Nav, Navbar } from "react-bootstrap";
import type LoginViewModel from "viewModels/loginViewModel";
import RootViewModel from "viewModels/rootViewModel";

interface AppHeaderProps {
  vm: RootViewModel | LoginViewModel;
  children?: React.ReactNode;
}

const AppHeader = observer((props: AppHeaderProps) => {
  const { children, vm } = props;

  let menu;
  if (vm instanceof RootViewModel) {
    const getUrl = Router.getChildUrlFactory(vm);

    menu = (
      <Nav className="mr-auto flex-column flex-lg-row">
        {vm.children.map((x: any, i: number) => (
          <Nav.Item key={x.name}>
            <Nav.Link
              href={getUrl(x)}
              className={classNames("text-center", { "ml-lg-4": i > 0, "mr-lg-4": i < vm.children.length - 1 })}
              id={`menu-${x.navigationName}`}
              active={vm.activeChild === x}
              eventKey={x.navigationName}>
              {x.name}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    );
  }

  let user;
  if (vm instanceof RootViewModel && vm.user) {
    user = (
      <Dropdown className="mt-2 mt-lg-0 text-center text-lg-left">
        <Dropdown.Toggle className="mr-2" as={Navbar.Text} id="current-user" style={{ cursor: "pointer" }}>
          <Icon icon={IconType.User} width={40} height={40} className="text-primary" />
          <span className="p-2 d-xl-none d-xxl-inline">{vm.user.name}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="1" onClick={vm.logout} id="logout">
            {vm.translateGeneral("logout")}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  return (
    <>
      <ColorDivider />
      <Header
        bg="white"
        expand="xl"
        containerWrap={true}
        containerFluid="md"
        className="shadow-sm mb-4"
        brand={
          <>
            <Icon icon={IconType.Edaz} width={60} height={60} className="mr-1 mr-md-5" />
            <span className="font-weight-bold text-uppercase align-middle">{vm.translateGeneral("title")}</span>
          </>
        }
        menu={menu}>
        {children}
        {user}
      </Header>
    </>
  );
});

export default AppHeader;
